<div class="margin-2rem-2-5rem">
  <mat-dialog-content class="terms-content">

    <h5 class="text-20px-bold-primary-center"
      mat-dialog-title [innerHTML]="getSafeHtml($safeNavigationMigration(terms?.TITLE))">
    </h5>

    <p class="lead" [innerHTML]="getSafeHtml($safeNavigationMigration(terms?.INTRODUCTION))">
    </p>
    @for (section of terms?.SECTIONS; track section; let i = $index) {
      <div class="terms-section">
        <h3>
          @if (i < 19) {
            <span>{{ i + 1 }}. </span>
          }
          {{ section?.title }}
        </h3>
        @for (paragraph of section?.paragraphs; track paragraph) {
          <p [innerHTML]="getSafeHtml(paragraph)">
          </p>
        }
        @if (section?.bullets?.length) {
          <ul>
            @for (bullet of section?.bullets; track bullet) {
              <li [innerHTML]="getSafeHtml(bullet)">
              </li>
            }
          </ul>
        }
        @if (section?.footer?.length) {
          @for (footer of section?.footer; track footer) {
            @if (isString(footer)) {
              <p [innerHTML]="getSafeHtml(footer)">
              </p>
            }
            @if (isObject(footer)) {
              <ul>
                @for (bullet of footer.bullets; track bullet) {
                  <li [innerHTML]="getSafeHtml(bullet)">
                  </li>
                }
              </ul>
            }
          }
        }
      </div>
    }
  </mat-dialog-content>

</div>

<div class="padding-2rem-2-5rem-border-top">
  <p class="text-bold-18px-my-5">
    Parkifly AB
  </p>
  <p class="text-bold-17px-my-5">
    Version 2026-07-10
  </p>
</div>